import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';

export default class UserGroupsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    
    this.loading = true;
    this.moreResults = false;
    this.groups = [];
    this.loadLimit = 20;
    this.currentPage = 1;
    
    // 加载用户
    this.loadUser(m.route.param('username'));
  }

  show(user) {
    super.show(user);
    
    // 用户加载完成后，加载群组列表
    if (this.user) {
      this.refresh();
    }
  }

  content() {
    if (this.groups.length === 0 && !this.loading) {
      return (
        <div className="UserGroupsPage">
          <Placeholder text={app.translator.trans('tf-custom-profile.forum.groups.empty')} />
        </div>
      );
    }

    let footer;

    if (this.loading) {
      footer = <LoadingIndicator />;
    } else if (this.moreResults) {
      footer = (
        <div className="UserGroupsPage-loadMore">
          <Button className="Button" onclick={this.loadMore.bind(this)}>
            {app.translator.trans('core.forum.user.posts_load_more_button')}
          </Button>
        </div>
      );
    }

    return (
      <div className="UserGroupsPage">
        <ul className="UserGroupsPage-list">
          {this.groups.map((group) => this.renderGroupItem(group))}
        </ul>
        <div className="UserGroupsPage-loadMore">{footer}</div>
      </div>
    );
  }

  renderGroupItem(group) {
    const coverImageUrl = group.cover_image 
      ? (group.cover_image.startsWith('http') 
          ? group.cover_image 
          : app.forum.attribute('baseUrl') + '/' + group.cover_image)
      : null;

    return (
      <li key={group.id} className="UserGroupsPage-item">
        <div 
          className="UserGroupsPage-item-card"
          onclick={() => this.viewGroup(group)}
        >
          {coverImageUrl ? (
            <div 
              className="UserGroupsPage-item-cover"
              style={{
                backgroundImage: `url(${coverImageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
          ) : (
            <div className="UserGroupsPage-item-cover UserGroupsPage-item-cover-placeholder">
              <i className="fa-light fa-users"></i>
            </div>
          )}
          <div className="UserGroupsPage-item-info">
            <div className="UserGroupsPage-item-header">
              <h3 className="UserGroupsPage-item-name">{group.name}</h3>
              {group.user_status && this.renderUserStatusTag(group.user_status)}
            </div>
            {group.description && (
              <div className="UserGroupsPage-item-description">
                {group.description}
              </div>
            )}
            <div className="UserGroupsPage-item-meta">
              <span className="UserGroupsPage-item-members">
                <i className="fa-light fa-users"></i>
                {group.member_count || 0} {app.translator.trans('tf-custom-profile.forum.groups.members')}
              </span>
              {group.stats && group.stats.discussions !== undefined && (
                <span className="UserGroupsPage-item-discussions">
                  <i className="fa-light fa-comments"></i>
                  {group.stats.discussions} {app.translator.trans('tf-custom-profile.forum.groups.discussions')}
                </span>
              )}
            </div>
          </div>
        </div>
      </li>
    );
  }

  renderUserStatusTag(userStatus) {
    if (!userStatus) {
      return null;
    }

    // 判断是否为组员：role 为 "member" 且 status 为 "approved"
    const isMember = userStatus.role === 'member' && userStatus.status === 'approved';
    
    // 判断是否为版主/管理员：role 为 "admin" 或 "moderator"
    const isModerator = userStatus.role === 'admin';

    if (isMember) {
      return (
        <span className="UserGroupsPage-item-tag UserGroupsPage-item-tag--joined">
          {app.translator.trans('tf-custom-profile.forum.groups.joined')}
        </span>
      );
    }

    if (isModerator) {
      return (
        <span className="UserGroupsPage-item-tag UserGroupsPage-item-tag--moderator">
          {app.translator.trans('tf-custom-profile.forum.groups.moderator')}
        </span>
      );
    }

    return null;
  }

  viewGroup(group) {
    if (group && group.id) {
      m.route.set(app.route('groupDetail', { id: group.id }));
    }
  }

  refresh() {
    this.loading = true;
    this.groups = [];
    this.currentPage = 1;

    m.redraw();

    this.loadResults().then(this.parseResults.bind(this));
  }

  loadResults(offset = 0) {
    if (!this.user) return Promise.resolve([]);

    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/social-groups/frontend/user-groups',
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      params: {
        page: Math.floor(offset / this.loadLimit) + 1,
        limit: this.loadLimit
      }
    });
  }

  loadMore() {
    this.loading = true;
    this.currentPage++;
    this.loadResults((this.currentPage - 1) * this.loadLimit).then(this.parseResults.bind(this));
  }

  parseResults(results) {
    this.loading = false;

    if (results && results.data) {
      // 过滤出用户已加入的群组（user_status 存在且 status 为 'approved'）
      const userId = this.user ? this.user.id() : null;
      const userGroups = results.data.filter(group => {
        if (group.user_status && group.user_status.status === 'approved') {
          return true;
        }
        return false;
      });

      // 避免重复添加
      const existingIds = this.groups.map(g => g.id);
      const newGroups = userGroups.filter(g => !existingIds.includes(g.id));
      
      this.groups.push(...newGroups);
      this.moreResults = results.data.length >= this.loadLimit && results.meta?.has_next_page;
    }

    m.redraw();

    return results;
  }
}
